import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Inquiry from "./Inquiry";

const InquiryList = () => {
  return (
    <div
      id="contact"
      className="relative w-full h-full py-14 lg:py-28 xl:py-36 blue-bg"
    >
      <div className="relative w-full h-full px-3 max-w-screen-xl mx-auto">
        <div className="relative w-fit h-fit flex justify-center items-center gap-2 mb-3">
          <div className="relative w-fit h-full mx-auto">
            <img
              className="!relative w-fit lg:w-full h-full max-h-9 lg:max-h-14 pb-1 object-contain"
              alt="비우고 채우고 로고"
              src="/images/logo.webp"
              loading="lazy"
              width={433}
              height={82}
            />
          </div>
          <div className=" relative w-fit h-fit bg-secondary text-white px-2 -mb-1">
            <h3 className="-mb-1 font-light">상세 견적문의</h3>
          </div>
        </div>
        <div className="relative w-full h-fit mx-auto grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div data-aos="fade-right" className=" relative w-full h-full">
            <div className=" relative w-full h-full bg-white p-2 lg:p-5 border-2 border-secondary rounded-3xl z-10">
              <Inquiry />
            </div>
          </div>
          <div data-aos="fade-left" className="relative w-full h-full">
            <div className="flex justify-center xs:justify-center items-center flex-wrap xs:flex-nowrap gap-3 mb-2 p-3 bg-secondary rounded-xl shadow-md">
              <div className="relative w-fit h-full">
                <img
                  className="!relative w-fit lg:w-full h-full max-h-9 lg:max-h-10 pb-1 object-contain"
                  alt="비우고 채우고 로고"
                  src="/images/whiteLogo.webp"
                  loading="lazy"
                  width={593}
                  height={136}
                />
              </div>
              <h3 className="font-medium text-point -mb-2">
                실시간&nbsp;견적현황
              </h3>
            </div>
            <InquiryCard />
          </div>
        </div>
      </div>
    </div>
  );
};

function InquiryCard() {
  let slidesviews = 9;
  return (
    <div className="relative w-full h-full max-h-80 lg:max-h-[480px] rounded-2xl shadow-2xl overflow-hidden border-2 border-secondary bg-white">
      <Swiper
        spaceBetween={30}
        direction={"vertical"}
        centeredSlides={true}
        loop={true} // loop 여부
        // loopedSlides={3}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        slidesPerView={slidesviews}
        className="mySwiper relative w-full h-full pt-8"
      >
        {inquiries.map((v, i) => (
          <SwiperSlide key={i}>
            <div className="relative w-full h-full grid grid-cols-11 items-center lg:gap-5 lg:px-5 lg:py-2">
              <p className="col-span-4 text-center py-1 text-sm lg:text-base scale-75 lg:scale-100 bg-secondary text-white rounded-full">
                {v.type}
              </p>
              <p className="col-span-2 scale-75 lg:scale-95 text-base">
                {v.createdAt}
              </p>
              <p className="col-span-2 text-center text-base scale-75 lg:scale-100">
                {v.name[0] + "00"}
              </p>

              <div className="col-span-3 relative w-full h-fit pt-0.5 text-center bg-secondary text-white rounded-full">
                <p className="text-sm py-1 lg:text-base scale-75 lg:scale-100">
                  {v.completeYn}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default InquiryList;

const inquiries = [
  {
    createdAt: "08:38:26",
    name: "안혜진",
    type: "유품정리",
    category: "긴급",
    completeYn: "야간예약완료",
  },
  {
    createdAt: "08:50:57",
    name: "이영천",
    type: "쓰레기집청소",
    category: "일반",
    completeYn: "예약완료",
  },
  {
    createdAt: "10:24:15",
    name: "김리나",
    type: "유품정리",
    category: "일반",
    completeYn: "예약중",
  },
  {
    createdAt: "12:15:20",
    name: "전리나",
    type: "고독사청소",
    category: "긴급",
    completeYn: "예약완료",
  },
  {
    createdAt: "13:21:49",
    name: "박리나",
    type: "고독사청소",
    category: "긴급",
    completeYn: "야간예약완료",
  },
  {
    createdAt: "13:52:15",
    name: "김리나",
    type: "유품정리",
    category: "긴급",
    completeYn: "야간예약완료",
  },
  {
    createdAt: "20:14:19",
    name: "김리나",
    type: "창고정리",
    category: "긴급",
    completeYn: "예약중",
  },
  {
    createdAt: "08:50:57",
    name: "이영천",
    type: "사무실정리",
    category: "일반",
    completeYn: "예약완료",
  },
  {
    createdAt: "10:24:15",
    name: "김리나",
    type: "고독사청소",
    category: "일반",
    completeYn: "진행완료",
  },
  {
    createdAt: "21:26:43",
    name: "정리나",
    type: "빈집정리",
    category: "일반",
    completeYn: "예약완료",
  },
  {
    createdAt: "21:26:43",
    name: "정리나",
    type: "고독사청소",
    category: "일반",
    completeYn: "진행완료",
  },
  {
    createdAt: "21:26:43",
    name: "정리나",
    type: "고독사청소",
    category: "일반",
    completeYn: "진행완료",
  },
  {
    createdAt: "12:15:20",
    name: "전리나",
    type: "빈집정리",
    category: "긴급",
    completeYn: "진행중",
  },
  {
    createdAt: "13:21:49",
    name: "박리나",
    type: "창고정리",
    category: "긴급",
    completeYn: "진행중",
  },
  {
    createdAt: "14:25:49",
    name: "유리나",
    type: "특수청소",
    category: "긴급",
    completeYn: "진행중",
  },
];
